// Do not restore scroll position by browsers back/forward buttons
import { isSkipScrollTab } from 'Utils/router';
import { getMaxScrollTop } from 'Utils/view';

window.history.scrollRestoration = 'manual';

export function scrollBehavior(to, from, savedPosition) {
  // for initial load 'to' and 'from' are the same object
  // but scroll is not needed if page stay the same
  if ((to !== from && to.path === from.path) || isSkipScrollTab(to, from)) {
    return null;
  }
  // return savedPosition only if scroll position is less than it can be
  // e.g. load more clicked which make page more height
  if (savedPosition && savedPosition.y <= getMaxScrollTop()) {
    return savedPosition;
  }

  return { x: 0, y: 0 };
}
